import { AccessSection } from '@/components/settings/AccessSection'
import { AppearanceSection } from '@/components/settings/AppearanceSection'
import { AudioSection } from '@/components/settings/AudioSection'
import { ProfileSection } from '@/components/settings/ProfileSection'
import { SftpSection } from '@/components/settings/SftpSection'
import { VideoSection } from '@/components/settings/VideoSection'
import { useAuth } from '@/contexts/AuthContext'
import { HUMINT_EXTENSION_ID, useExtensionEnabled } from '@/hooks/use-extensions'
import { useTheme } from '@/theme'
import { useAccessData } from './hooks/useAccessData'
import { useAudioSettings } from './hooks/useAudioSettings'
import { useLanguagePreference } from './hooks/useLanguagePreference'
import { useProfileUnit } from './hooks/useProfileUnit'
import { useSftpPasswordReset } from './hooks/useSftpPasswordReset'
import { useVideoSettings } from './hooks/useVideoSettings'

export function ProfileSectionConnected() {
  const { user } = useAuth()
  // The unit exists only while HUMINT is on: the API neither takes nor returns it otherwise.
  const humint = useExtensionEnabled(HUMINT_EXTENSION_ID)
  const unit = useProfileUnit()
  if (!user) return null
  return <ProfileSection user={user} unit={humint.enabled ? unit : undefined} />
}

export function AppearanceSectionConnected() {
  const { theme, setTheme, railLabels, setRailLabels } = useTheme()
  const { language, setLanguage } = useLanguagePreference()
  return (
    <AppearanceSection
      theme={theme}
      language={language}
      railLabels={railLabels}
      onThemeChange={setTheme}
      onLanguageChange={setLanguage}
      onRailLabelsChange={setRailLabels}
    />
  )
}

export function SftpSectionConnected() {
  const { user } = useAuth()
  const { resetting, password, reset } = useSftpPasswordReset()
  if (!user) return null
  return (
    <SftpSection
      username={user.username}
      password={password}
      resetting={resetting}
      onReset={reset}
    />
  )
}

export function AccessSectionConnected() {
  const { memberships, lakeGrants } = useAccessData()
  return <AccessSection memberships={memberships} lakeGrants={lakeGrants} />
}

export function AudioSectionConnected() {
  const state = useAudioSettings()
  return <AudioSection state={state} />
}

export function VideoSectionConnected() {
  const state = useVideoSettings()
  return <VideoSection state={state} />
}
